<template>
  <div style="height: 400px">
    <div class="d-flex align-center mt-7">
      <v-icon
        class="mr-2"
        size="30"
        :color="$vuetify.theme.primary || '#39424e'"
        @click="$emit('back')"
      >
        mdi-arrow-left-circle
      </v-icon>
      <span class="ml-3 navigation-title"> Finalização </span>
    </div>
    <v-row class="ma-0 mt-8" dense>
      <v-col cols="12" style="font-size: 1.3rem !important">
        <v-expand-transition class="mb-3">
          <h3 class="mb-3">Apólice emitida com sucesso!</h3>
        </v-expand-transition>
        <v-expand-transition v-if="!withoutApolice && !withoutBoleto">
          <p>
            Aguarde uns minutos, abaixo você encontrará dois botões, um para visualizar apólice e
            outro para visualizar o boleto. Em breve você receberá um e-mail com
            esses documentos e informações para contato.
          </p>
        </v-expand-transition>
        <v-expand-transition v-else>
          <p>
            Pode aguardar alguns segundos? Em breve seu boleto e sua apólice
            estará disponível para baixar. Esses documentos serão enviados para
            o seu e-mail também.
          </p>
        </v-expand-transition>
      </v-col>

      <v-col
        v-if="!withoutApolice && !withoutBoleto"
        cols="12"
        style="display: flex; gap: 10px; flex-wrap: wrap"
      >
        <v-expand-transition>
          <v-btn
            class="primary-button btns"
            :style="
              $vuetify.theme.primary
                ? `color: var(--custom-white-second-color) !important; background-color: ${$vuetify.theme.primary} !important;`
                : 'color: var(--custom-white-second-color) !important;'
            "
            @click="downloadApolice"
            :loading="loadingApolice"
            >Baixar Apólice <v-icon class="ml-2">mdi-download</v-icon></v-btn
          >
        </v-expand-transition>
        <v-expand-transition>
          <v-btn
            class="primary-button btns"
            :style="
              $vuetify.theme.primary
                ? `color: var(--custom-white-second-color) !important; background-color: ${$vuetify.theme.primary} !important;`
                : 'color: var(--custom-white-second-color) !important;'
            "
            @click="downloadBoleto"
            :loading="loadingBoleto"
            >Baixar Boleto <v-icon class="ml-2">mdi-download</v-icon></v-btn
          >
        </v-expand-transition>
      </v-col>
      <v-progress-circular
        size="40"
        class="ma-auto"
        indeterminate
        :color="$vuetify.theme.primary || 'primary'"
        v-else
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import GeneralServices from "../../../../services/GeneralServices";
export default {
  props: {
    user: Object,
  },
  data() {
    return {
      api: new ApiService(),
      proposal: null,
      loadingApolice: false,
      loadingBoleto: false,
      mobile: false,
      insured: null,
      withoutApolice: true,
      withoutBoleto: true,
      apolice: null,
      boleto: null,
      generalService: new GeneralServices()
    };
  },
  async created() {
    this.proposal = JSON.parse(localStorage.getItem("resultProposal"));
    this.insured = JSON.parse(localStorage.getItem("user"));

    await this.sendMail();

    setTimeout(async () => {
      await this.getApolice();
      await this.getBoleto();
    }, 90000);
  },
  methods: {
    async sendMail() {
      await this.api
        .post("send-mail", {
          token: localStorage.getItem("token"),
          id_endosso: this.proposal.proposal.id_endosso,
          insured: this.insured,
          id_parceiro: localStorage.getItem("id_parceiro"),
          creator_cpf: localStorage.getItem("creator_cpf"),
        })
        .then((response) => {
          localStorage.setItem("apiErrorDescription", "Erro ao enviar o email final!");
          console.log(response);
        });
    },
    async getApolice() {
      await this.api
        .post("get-apolice", {
          id_endosso: this.proposal.proposal.id_endosso,
          token: localStorage.getItem("token"),
        })
        .then((res) => {
          const apolices = res.ConsultaCertificadoApoliceTable1;
          if (apolices.length > 0) {
            this.apolice = apolices;
            this.withoutApolice = false;
          } else {
            this.withoutApolice = true;
            this.getApolice();
          }
        }).catch(() => { localStorage.setItem("apiErrorDescription", "Erro ao pegar a apólice!"); })
    },
    async getBoleto() {
      await this.api
        .post("boleto-apolice", {
          id_endosso: this.proposal.proposal.id_endosso,
          token: localStorage.getItem("token"),
        })
        .then((res) => {
          if (res.ConsultaBoletoApoliceTable1.length > 0) {
            this.boleto = res.ConsultaBoletoApoliceTable1;
            this.withoutBoleto = false;
          } else {
            this.withoutBoleto = true;
            this.getBoleto();
          }
        }).catch(() => { localStorage.setItem("apiErrorDescription", "Erro ao pegar o boleto!"); })
    },

    downloadBoleto() {
      this.loadingBoleto = true;
      const link = document.createElement("a");
      link.href = `data:application/pdf;base64,${this.boleto[0].Base64Documentos}`;
      link.setAttribute("download", "boleto.pdf");
      document.body.appendChild(link);
      link.click();
      this.loadingBoleto = false;
    },
    downloadApolice() {
      this.loadingApolice = true;
      this.apolice.map((item, index) => {
        const link = document.createElement("a");
        link.href = `data:application/pdf;base64,${item.Base64Documentos}`;
        link.setAttribute("download", `Certificado Apólice - ${index + 1}.pdf`);
        document.body.appendChild(link);
        link.click();
      });
      this.loadingApolice = false;
    },
    async createQuotationInWF() {
      const cpf_segurado =
        this.proposal.nr_cnpj_cpf_segurado.substring(0, 3) +
        "." +
        this.proposal.nr_cnpj_cpf_segurado.substring(3, 6) +
        "." +
        this.proposal.nr_cnpj_cpf_segurado.substring(6, 9) +
        "-" +
        this.proposal.nr_cnpj_cpf_segurado.substring(9, 11);
      const requestParams = {
        id_parceiro: localStorage.getItem("id_parceiro"),
        creator_cpf: localStorage.getItem("creator_cpf"),
        description:
          "Cotação RC Médico Profissional cotada pela Fator Seguradora",
        totalPrize: 0,
        totalComissionPct: 0,
        type: "Cotação",
        origin: null,
        contactPhoneNumber: null,
        corporateName: this.proposal.nm_segurado,
        cnpj: cpf_segurado,
        quotationTypeId: 47,
        personType: "PF",
      };
      await this.api
        .post(
          "https://globusesteiraraw.azurewebsites.net/api/create-quotation-open",
          {
            ...requestParams,
          }
        )
        .then((response) => {
          if (response.data.cd_retorno != 0) {
            this.$toast.error(response.data.nm_retorno);
          } else {
            this.$toast.error(
              response.data.nm_retorno || "Ocorreu um erro na comunicacao!"
            );
          }
        }).catch(() => { localStorage.setItem("apiErrorDescription", "Erro ao criar cotação WORK FLOW!"); })
    },
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 600px) {
  .btns {
    width: 100% !important;
  }
}
</style>
